<template>
  <a
    :id="`hover-element-${itemKey}`"
    class="directory-field-hover bg-white rounded text-main"
    @click.stop
  >
    <template v-if="fetching || !item || error">
      <div
        v-if="fetching"
        class="w-100 text-center py-4"
      >
        <b-spinner small />
        <div class="mt-1">
          Loading
        </div>
      </div>
      <template v-if="error">
        <div class="p-2">
          <span class="text-danger">
            Error getting data.
          </span>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="d-flex justify-content-between align-items-center border-default border-b p-1">
        <a
          :href="item.url"
          target="_blank"
          class="text-truncate"
        >{{ item.url }}</a>
        <b-button
          v-clipboard:copy="item.url"
          v-clipboard:success="copySuccess"
          class="text-secondary m-0 ml-3 h-auto p-0 text-md text-nowrap"
          variant="transparent"
          @click.stop
        >
          <GjIcon
            name="Copy"
            class="copy-icon"
          />
          Copy URL
        </b-button>
      </div>
      <div class="d-flex px-1 pt-1 flex-column file-info">
        <template
          v-if="!item.isFolder"
        >
          <div
            v-if="isImage"
            class="d-flex field"
          >
            <div class="field-name text-secondary">
              Preview
            </div>
            <div>
              <img
                :src="item.previewLink"
              >
            </div>
          </div>
          <div
            class="d-flex field"
          >
            <div class="field-name text-secondary">
              Permission
            </div>
            <div class="text-main">
              {{ item.isPublic ? 'Public' : 'Private' }}
            </div>
          </div>
          <div class="d-flex field">
            <div class="field-name text-secondary">
              Content Type
            </div>
            <div class="text-main">
              {{ item.contentType }}
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="d-flex field"
          >
            <div class="field-name text-secondary">
              Folder
            </div>
          </div>
        </template>
      </div>
    </template>
  </a>

</template>

<script>
export default {
  name: 'DirectoryFieldHover',
  props: {
    itemKey: {
      type: String,
      default: null,
    },
    error: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
    fetching: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isImage() { return this.item.contentType.includes('image') },
  },
}
</script>

<style scoped>
  .directory-field-hover{
    position:relative;
    /* top:20px; */
    /* z-index: 50; */
    display: block;
    width:450px;
    cursor: default;
    font-size:12px;
    /* left:0; */
    /* transform: 200ms; */
  }

  .directory-field-hover .copy-icon{
    margin-right:5px;
  }

  .file-info .field{
    margin-bottom:13px;
  }
  .file-info .field-name{
    width:150px;
  }
  .file-info img{
    max-height:90px;
    max-width:250px;
  }

</style>
